import { useEffect } from "react";
import { format, parseISO, subDays } from "date-fns";
import useStatusStore from "../../store/statusStore";
import { getLocation } from "../../config/location";

export const formatClosureDate = (isoDate) => format(parseISO(isoDate), "dd.MM.");

// Hinweis auf eine kommende oder laufende Betriebsschließung (z. B. Umzug).
const ClosureBanner = () => {
    const { closure, fetchClosure } = useStatusStore();

    useEffect(() => {
        fetchClosure();
    }, [fetchClosure]);

    if (!closure) {
        return null;
    }

    const location = getLocation();
    const lastOpenDay = formatClosureDate(
        format(subDays(parseISO(closure.startDate), 1), "yyyy-MM-dd"),
    );

    return (
        <div className="bg-enedemgreen text-white text-center text-sm px-4 py-2">
            <p className="font-semibold">
                {closure.note ||
                    `Vom ${formatClosureDate(closure.startDate)} bis ${formatClosureDate(closure.endDate)} haben wir geschlossen.`}
            </p>
            {!closure.active && (
                <p>
                    Bis einschließlich {lastOpenDay} sind wir wie gewohnt für
                    Sie da
                    {!location.venue && ` – noch in der ${location.street}`}
                    .
                </p>
            )}
        </div>
    );
};

export default ClosureBanner;
